<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 7.00098C13 6.44869 12.5523 6.00098 12 6.00098C11.4477 6.00098 11 6.44869 11 7.00098V11.001H7C6.44772 11.001 6 11.4487 6 12.001C6 12.5533 6.44772 13.001 7 13.001H11V17.001C11 17.5533 11.4477 18.001 12 18.001C12.5523 18.001 13 17.5533 13 17.001V13.001H17C17.5523 13.001 18 12.5533 18 12.001C18 11.4487 17.5523 11.001 17 11.001H13V7.00098Z"
    fill="currentColor"
/>
